import React from 'react'
import {Col, Divider, Form, Row} from "antd";
import RecipeName from "./RecipeName";
import RecipeDescription from "./RecipeDescription";
import RecipeCode from "./RecipeCode";
import RecipeFilePath from "./RecipeFilePath";

const RecipeHeaders = () => {

    return(
        <React.Fragment>
            <h3>Reçete Bilgileri</h3>
            <Divider />
            <Row justify={'start'}>
                <Col span={24}>
                    <Form
                        labelAlign={'left'}
                        labelCol={{span: 6}}
                        wrapperCol={{span: 16}}
                    >
                        <RecipeName />
                        <RecipeCode />
                        <RecipeFilePath />
                        <RecipeDescription />
                    </Form>
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default RecipeHeaders